"use strict";
/** Επερχόμενα ραντεβού — κοινό web & mobile */
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterUpcomingScheduledAppointments = filterUpcomingScheduledAppointments;
function filterUpcomingScheduledAppointments(appointments, range) {
    const now = Date.now();
    const fromMs = range.from.getTime();
    const toMs = range.to.getTime();
    return appointments
        .filter((a) => {
        if (a.status !== 'SCHEDULED')
            return false;
        const start = new Date(a.startAt).getTime();
        return start >= fromMs && start < toMs && new Date(a.endAt).getTime() >= now;
    })
        .sort((a, b) => a.startAt.localeCompare(b.startAt));
}
